import { useState } from "react";
import { useTranslation } from "react-i18next";

import AddItemDialog from "../../../../components/editableItemList/addItemDialog/AddItemDialog";
import { IDocument } from "../../../../models/document";
import AddDocumentItemForm from "../forms/addDocumentItemForm/AddDocumentItemForm";
import "./AddDocumentItemDialog.scss";

interface AddDocumentItemDialogProps {
  isOpen: boolean;
  closeDialog: () => void;
  onSave: (item: IDocument) => void;
  itemToEdit?: IDocument | null;
}

const emptyFormData: IDocument = {
  id: "",
  name: "",
  file: null,
  documentType: null,
};

const isKeyOfFormData = (key: string): key is keyof IDocument => {
  return key in emptyFormData;
};

const AddDocumentItemDialog = (props: AddDocumentItemDialogProps) => {
  const { t } = useTranslation();
  const { isOpen, closeDialog, onSave, itemToEdit } = props;

  const [formData, setFormData] = useState<IDocument>(
    itemToEdit || emptyFormData,
  );
  const [isFormValid, setIsFormValid] = useState(false);

  const onChange = (fieldId: string, value: string | File) => {
    if (!isKeyOfFormData(fieldId)) {
      console.error(`Invalid fieldId of input: ${fieldId}`);
      return;
    }

    setFormData({ ...formData, [fieldId]: value });
  };

  return (
    <AddItemDialog
      className="add-document-dialog"
      isOpen={isOpen}
      title={t("addNewDocument")}
      formData={formData}
      isFormValid={isFormValid}
      closeDialog={closeDialog}
      onSave={onSave}
      itemToEdit={itemToEdit}
    >
      <AddDocumentItemForm
        formData={formData}
        onChange={onChange}
        setIsFormValid={(isValid) => setIsFormValid(isValid)}
      />
    </AddItemDialog>
  );
};

export default AddDocumentItemDialog;
